import { render, staticRenderFns } from "./promotionTime.vue?vue&type=template&id=bc71cf48&scoped=true"
import script from "./promotionTime.vue?vue&type=script&lang=js"
export * from "./promotionTime.vue?vue&type=script&lang=js"
import style0 from "./promotionTime.vue?vue&type=style&index=0&id=bc71cf48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc71cf48",
  null
  
)

export default component.exports